import Vue from "vue";

export const companiesService = {
  list,
  getById,
  create,
  update
};

function list() {
  return Vue.axios.get("v1/companies");
}

function getById(id) {
  return Vue.axios.get(`v1/companies/${id}`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("corporate_tax_id", payload.corporate_tax_id);
  formData.set("contact_email", payload.contact_email);
  formData.set("contact_phone_number", payload.contact_phone_number);
  formData.set("contact_name", payload.contact_name);

  if (payload.logo) {
    formData.set("logo", payload.logo);
  }

  return Vue.axios.post("v1/companies", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function update(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("corporate_tax_id", payload.corporate_tax_id);
  formData.set("contact_email", payload.contact_email);
  formData.set("contact_phone_number", payload.contact_phone_number);
  formData.set("contact_name", payload.contact_name);

  if (payload.logo) {
    formData.set("logo", payload.logo);
  }

  return Vue.axios.patch(`v1/companies/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
